var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookingEmptyStateIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 151,
    viewBox: "0 0 144 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_753_9223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.279 107.168C113.279 90.3146 132.257 88.4034 120.049 60.859C101.264 18.4761 85.7898 5.07861 58.0087 14.6028C45.4456 18.9098 4.15893 38.3647 2.32239 58.6498C2.89622 80.957 18.9486 68.5604 22.9757 95.0566C27.0029 121.553 39.4167 125.484 59.7452 125.811C80.0737 126.138 98.2061 115.717 103.279 107.168Z",
    fill: "#87A9B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7305 139.224C103.633 130.275 120.989 139.122 125.726 108.718C133.014 61.9358 127.127 41.8774 98.0031 34.705C84.8328 31.4615 38.6215 25.3549 25.8341 41.7623C13.9995 61.2384 34.6371 59.4622 23.4535 84.4447C12.2699 109.427 20.7594 119.664 38.0382 131.178C55.317 142.693 76.6493 143.764 85.7305 139.224Z",
    fill: "#E3EEF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4361 107.858C25.1306 104.608 28.4708 100.961 31.5971 101.616C35.1347 102.357 40.3843 106.443 40.1667 114.495C39.949 122.546 58.52 122.379 56.476 136.48C55.9259 140.275 40.1271 156.102 30.3381 143.924C24.5704 136.749 15.9156 138.163 10.6848 135.482C5.45389 132.802 10.6501 121.332 15.2079 119.719C19.7657 118.105 21.1216 112.296 23.4361 107.858Z",
    fill: "#CFDDE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.374 53.8299C112.687 53.2806 117.56 52.4658 119.113 52.2953C122.45 51.9288 120.248 42.1545 122.157 46.0653C123.421 48.6546 120.904 50.9852 128.898 54.0122C132.203 55.2636 125.076 52.6678 123.31 56.9638C122.835 58.1202 121.352 65.946 120.317 60.9139C119.536 57.1214 120.343 55.7739 114.374 53.8299Z",
    fill: "#87A9B3",
    stroke: "#87A9B3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.166 92.166H63.166V106.166H51.4993C50.8805 106.166 50.287 105.92 49.8494 105.483C49.4118 105.045 49.166 104.452 49.166 103.833V92.166Z",
    fill: "#105368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.166 75.833H49.166V89.833H63.166V75.833Z",
    fill: "#105368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5 75.833H65.5V89.833H79.5V75.833Z",
    fill: "#105368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.832 75.833H81.832V89.833H95.832V75.833Z",
    fill: "#105368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5 92.166H65.5V106.166H79.5V92.166Z",
    fill: "#105368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.832 92.166H95.832V103.833C95.832 104.452 95.5862 105.045 95.1486 105.483C94.711 105.92 94.1175 106.166 93.4987 106.166H81.832V92.166Z",
    fill: "#105368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4993 66.5H93.4994C94.1182 66.5 94.7117 66.7458 95.1493 67.1834C95.5869 67.621 95.8327 68.2145 95.8327 68.8333V73.5H49.166V68.8333C49.166 68.2145 49.4118 67.621 49.8494 67.1834C50.287 66.7458 50.8805 66.5 51.4993 66.5Z",
    fill: "#105368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.916 61.833C58.3801 61.833 58.8253 62.0174 59.1535 62.3456C59.4816 62.6738 59.666 63.1189 59.666 63.583V66.4997H56.166V63.583C56.166 63.1189 56.3504 62.6738 56.6786 62.3456C57.0068 62.0174 57.4519 61.833 57.916 61.833Z",
    fill: "#105368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.082 61.833C87.5462 61.833 87.9913 62.0174 88.3195 62.3456C88.6477 62.6738 88.832 63.1189 88.832 63.583V66.4997H85.332V63.583C85.332 63.1189 85.5164 62.6738 85.8446 62.3456C86.1728 62.0174 86.6179 61.833 87.082 61.833Z",
    fill: "#105368"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_753_9223"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 143,
    height: 151,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingEmptyStateIllustration);
export default __webpack_public_path__ + "static/media/booking_emptyState_illustration.c524e804803f7ae13ec7efea2cb40827.svg";
export { ForwardRef as ReactComponent };